import TranslateOutlinedIcon from "@mui/icons-material/TranslateOutlined";
import InlineButton from "components/shared/InlineButton";
import { useState } from "react";
import { useFieldArray } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { TDefaultAutocompleteOption } from "../FormComponent/AutocompleteFormComponent";
import TextFormComponent from "../FormComponent/TextFormComponent";
import LightPlusBtn from "../LightPlus";
import SelectTranslationModal from "./SelectTranslationModal";
import styles from "./style.module.scss";

interface INameTranslationWrapper {
    control: any;
    originalName: string;
    nameLabel?: string;
}

const NameTranslationWrapper = ({ control, originalName, nameLabel = "" }: INameTranslationWrapper) => {
    const [t] = useTranslation();
    const [openModal, setOpenModal] = useState(false);
    const { fields, append, remove } = useFieldArray({
        control,
        name: "nameTranslations",
    });
    const label = nameLabel || t("Channels.Name");

    const handleSelect = ({ option, translation }: { option: string | null; translation: string }) => {
        if (!option) return;
        append({
            locale: option,
            name: translation,
        });
    };

    const formatLabel = (locale: string) => {
        const localeName = t(`Locales.${locale}`);
        return `${label} - ${localeName}`;
    };

    const currentSelection = fields.map((field: any) => field.locale);

    return (
        <div className={styles["name-translation-wrapper"]}>
            <InlineButton
                icon={<TranslateOutlinedIcon sx={{ width: 14, height: 14 }} />}
                onClick={() => setOpenModal(true)}
                disabled={!originalName?.length}
            >
                {t("NewTitle.AddTranslation")}
            </InlineButton>
            {fields?.length > 0 && (
                <div className={styles["fields-wrapper"]}>
                    {fields.map((field: any, idx) => (
                        <div key={field.id} className={styles["field-wrapper"]}>
                            <TextFormComponent
                                label={formatLabel(field.locale)}
                                control={control}
                                fullWidth
                                controlName={`nameTranslations.${idx}.name`}
                            />
                            <div className={styles["remove-btn"]}>
                                <LightPlusBtn
                                    tooltipTitle={t("NewTitle.DeleteTranslation")}
                                    onClick={() => remove(idx)}
                                    type="minus"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <SelectTranslationModal
                open={openModal}
                onClose={() => setOpenModal(false)}
                originalName={originalName}
                handleSelect={handleSelect}
                currentSelection={currentSelection}
                nameLabel={label}
            />
        </div>
    );
};

export default NameTranslationWrapper;
